(function () {
  'use strict';

  var INTERVAL_MS = 2000;
  var RESUME_MS = 2000;
  var MOBILE_QUERY = '(max-width: 989px)';
  var VISIBLE = 2;

  function gapPx(track) {
    var styles = window.getComputedStyle(track);
    return parseFloat(styles.columnGap || styles.gap) || 0;
  }

  function measure(slider, track) {
    var gap = gapPx(track);
    var cardW = (slider.clientWidth - gap * (VISIBLE - 1)) / VISIBLE;
    slider.style.setProperty('--taupe-story-stat-card-w', cardW + 'px');
    slider.style.setProperty('--taupe-story-stat-step', cardW + gap + 'px');
    return { cardW: cardW, gap: gap, step: cardW + gap };
  }

  function initStoryStatsSliders() {
    document.querySelectorAll('[data-taupe-story-stats-slider]').forEach(function (slider) {
      if (slider.getAttribute('data-taupe-story-stats-ready') === 'true') return;
      slider.setAttribute('data-taupe-story-stats-ready', 'true');

      var track = slider.querySelector('[data-taupe-story-stats-track]');
      if (!track) return;

      var slides = track.querySelectorAll('.taupe-lane-story__stat');
      if (slides.length < 2) return;

      var index = 0;
      var timer;
      var userScrolling = false;
      var scrollEndTimer;
      var mq = window.matchMedia(MOBILE_QUERY);
      var maxIndex = Math.max(0, slides.length - VISIBLE);

      function scrollTarget(i, metrics) {
        return i * metrics.step;
      }

      function indexFromScroll(metrics) {
        return Math.max(0, Math.min(maxIndex, Math.round(slider.scrollLeft / metrics.step)));
      }

      function goTo(i, smooth) {
        index = i;
        if (mq.matches) {
          var metrics = measure(slider, track);
          slider.scrollTo({
            left: scrollTarget(index, metrics),
            behavior: smooth ? 'smooth' : 'auto'
          });
        } else {
          slider.scrollLeft = 0;
        }
      }

      function next() {
        goTo(index >= maxIndex ? 0 : index + 1, true);
      }

      function stop() {
        window.clearInterval(timer);
        timer = null;
      }

      function restart() {
        stop();
        if (mq.matches && maxIndex > 0 && !userScrolling) {
          timer = window.setInterval(next, INTERVAL_MS);
        }
      }

      function onScroll() {
        if (!mq.matches || userScrolling) return;
        var metrics = measure(slider, track);
        var nextIndex = indexFromScroll(metrics);
        if (nextIndex !== index) {
          index = nextIndex;
        }
      }

      function onUserScrollStart() {
        userScrolling = true;
        stop();
        window.clearTimeout(scrollEndTimer);
      }

      function onUserScrollEnd() {
        window.clearTimeout(scrollEndTimer);
        scrollEndTimer = window.setTimeout(function () {
          if (mq.matches) {
            var metrics = measure(slider, track);
            index = indexFromScroll(metrics);
          }
          userScrolling = false;
          restart();
        }, RESUME_MS);
      }

      function onResize() {
        if (mq.matches) {
          measure(slider, track);
          goTo(index, false);
        }
      }

      function activate() {
        maxIndex = Math.max(0, slides.length - VISIBLE);
        if (mq.matches) {
          measure(slider, track);
          if (index > maxIndex) index = 0;
          goTo(index, false);
          restart();
        } else {
          stop();
          index = 0;
          slider.scrollLeft = 0;
          slider.style.removeProperty('--taupe-story-stat-card-w');
          slider.style.removeProperty('--taupe-story-stat-step');
        }
      }

      slider.addEventListener('touchstart', onUserScrollStart, { passive: true });
      slider.addEventListener('touchend', onUserScrollEnd, { passive: true });
      slider.addEventListener('touchcancel', onUserScrollEnd, { passive: true });
      slider.addEventListener('scroll', onScroll, { passive: true });

      window.addEventListener('resize', onResize);

      if (typeof mq.addEventListener === 'function') {
        mq.addEventListener('change', activate);
      } else if (typeof mq.addListener === 'function') {
        mq.addListener(activate);
      }

      activate();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStoryStatsSliders);
  } else {
    initStoryStatsSliders();
  }

  document.addEventListener('shopify:section:load', initStoryStatsSliders);
})();
